import { IPoliticalPartyPagedRequest } from '../../../../model/sge/political-party/request/political-party-paged-request';
import { IPoliticalPartyResponse } from '../../../../model/sge/political-party/response/political-party-response';

export type PoliticalPartySearchState = {
    parameters: IPoliticalPartyPagedRequest;
    searchTrigger: number;
    drawer: { open: boolean; record?: IPoliticalPartyResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const PoliticalPartySearchReducer = (state: PoliticalPartySearchState, action: any): PoliticalPartySearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
